export const setLightTheme = () => useState('light-theme', () => false)

export const setLightScrollTop = () => useState('light-scroll-top', () => false)

export const setHideScrollTop = () => useState('hide-scroll-top', () => false)

export const setFromError = () => useState('from-error-layout', () => false)
